import { render, staticRenderFns } from "./SkuInfoTable.vue?vue&type=template&id=12c88a9d&scoped=true"
import script from "./SkuInfoTable.vue?vue&type=script&lang=js"
export * from "./SkuInfoTable.vue?vue&type=script&lang=js"
import style0 from "./SkuInfoTable.vue?vue&type=style&index=0&id=12c88a9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c88a9d",
  null
  
)

export default component.exports